import TsaAuthorizationLetter from '@/components/authorizationLetter/index.vue'
let $vm
const plugin = {
  install (vue, pluginOptions = {}) {
    const AuthorizationLetter = vue.extend(TsaAuthorizationLetter)
    if (!$vm) {
      $vm = new AuthorizationLetter({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const authorizationLetter = {
      show (options = {}) {
        Object.keys(options).map(key => {
          $vm[key] = options[key]
        })
        $vm.init()
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaAuthorizationLetter) {
      vue.prototype.$TsaAuthorizationLetter = authorizationLetter
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/authorizationLetter/index.js